import { pubWorkflow } from '@views/main/api'
import { ElMessage, ElMessageBox } from 'element-plus'

export async function pubWorkflowConfirm() {
  try {
    await ElMessageBox.confirm('本次任务消耗10点权益点，是否需要继续生成企业信息？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
  } catch (error) {
    console.log(error)
  }
}
